import React, { useEffect, useRef, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
import { useJobs } from './JobProvider';
import { API_BASE_URL, API_ENDPOINTS } from '../../constants/api';
import { titleFor } from './JobProgressCard';
import { destinationForJob } from './jobDestination';

export const JobToastRegion = () => {
  const { jobs, itemsById = {} } = useJobs();
  const known = useRef(new Map());
  const [toasts, setToasts] = useState([]);
  useEffect(() => {
    const next = [];
    jobs.forEach((job) => {
      const previous = known.current.get(job.id);
      known.current.set(job.id, job.status);
      if (previous && previous !== job.status && ['completed', 'partial_completed'].includes(job.status)) next.push(job);
    });
    if (next.length) setToasts((current) => [...current, ...next].slice(-3));
  }, [jobs]);
  useEffect(() => {
    if (!toasts.length) return undefined;
    const timer = setTimeout(() => setToasts((current) => current.slice(1)), 12000);
    return () => clearTimeout(timer);
  }, [toasts]);
  return (
    <div className="job-toast-region" aria-live="polite" aria-label="Job notifications">
      {toasts.map((job) => {
        const artifact = job.artifact_refs?.find((item) => item.url || item.href);
        const downloadUrl = job.result_summary?.download_ready
          ? `${API_BASE_URL}${API_ENDPOINTS.JOB_DOWNLOAD(job.id)}`
          : null;
        const destination = destinationForJob(job, itemsById[job.id]);
        const title = titleFor(job);
        return <div className="job-toast" key={job.id} role="status"><CheckCircle2 aria-hidden="true" /><div><strong>{title} {job.status === 'partial_completed' ? 'partially completed' : 'completed'}</strong><p>{job.result_summary?.message || `${title} is ready.`}</p><div className="job-toast-actions">{destination && <a href={destination.href}>{destination.label}</a>}{downloadUrl ? <a href={downloadUrl} target="_blank" rel="noreferrer">Download result</a> : artifact && <a href={artifact.url || artifact.href}>View result</a>}</div></div><button type="button" onClick={() => setToasts((current) => current.filter((item) => item.id !== job.id))} aria-label="Dismiss notification"><X aria-hidden="true" /></button></div>;
      })}
    </div>
  );
};
